//devlopment
// export const algoliaAppID = '0DXTUWO9PQ';
// export const algoliaSearchID = 'bc0428a3dc4963ba08e9d94d4f2f6d86'

//production
export const algoliaAppID = 'CG1744QXNJ';
export const algoliaSearchID = '6630b458c52c60e32457683fc602c6f6';
